import React from 'react';
import cx from 'classnames';
import styles from './msDynamicsConfigurationView.module.scss';
import isEqual from 'is-equal';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import _ from 'lodash';
import {
  Row, Col, Card, ButtonGroup,
  FormGroup, InputGroup, FormControl, Form,
  Collapse,
} from 'react-bootstrap';
// import { Button } from "react-bootstrap/lib/InputGroup";
import OpportunityFieldDropdown from "../fields/OpportunityFieldDropdown";
import SwitchButton from 'src/components/switchButton';
import SendButton from 'src/legacy/components/SendButton';
import CustomFieldDropdown from "../fields/CustomFieldDropdown";
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button';
import Toast from 'src/components/toast';


class MsDynamicsConfigurationView extends React.Component {
  constructor(props) {
    super(props);
    let primaryIntegration = this.props.integration;
    this.state = {
      primaryId: primaryIntegration && primaryIntegration.id,
      primaryEmail: primaryIntegration && _.get(primaryIntegration,"configuration.email",""),
      primaryInstance: primaryIntegration && _.get(primaryIntegration,"configuration.instance",""),
      primarySyncReadAssetEvent: primaryIntegration && _.get(primaryIntegration,"configuration.syncReadAssetEvent",false),
      primarySyncReadConversationEvent: primaryIntegration && _.get(primaryIntegration,"configuration.syncReadConversationEvent",false),
      primarySyncReshareConversationEvent: primaryIntegration && _.get(primaryIntegration,"configuration.syncReshareConversationEvent",false),
      primarySyncLeadCreatedEvent: primaryIntegration && _.get(primaryIntegration,"configuration.syncLeadCreatedEvent",false),
      primarySyncDeals: primaryIntegration && _.get(primaryIntegration,"configuration.syncDeals",false),
      primarySyncEmailSentEvent: primaryIntegration && _.get(primaryIntegration,"configuration.syncEmailSentEvent",false),
      primaryCreatedBy: primaryIntegration && _.get(primaryIntegration,"createdBy"),
      primarySyncAssetDownloadEvent: primaryIntegration && _.get(primaryIntegration,"configuration.syncAssetDownloadEvent"),
      errors: {},
      showAddFieldButton: true,
      opportunityFields: this.props.opportunityFields,
      removeCustomFields: [],
      customFields: this.props.customFields,
      newCustomFields: [],
      editMode: false,
      sharedFieldsSync: false,
      sharedFieldsEdit: false,
      toggleCollapse: true,
    }

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);
    this.prepareAdminConfiguration = this.prepareAdminConfiguration.bind(this);
    this.prepareUserConfiguration = this.prepareUserConfiguration.bind(this);
    this._handlePrimaryResetClicked = this._handlePrimaryResetClicked.bind(this);

    this._addNewCustomField = this._addNewCustomField.bind(this);
    this._removeCustomField = this._removeCustomField.bind(this);
    this._removeNewCustomField = this._removeNewCustomField.bind(this);
    this._renderCustomFieldsInEditMode = this._renderCustomFieldsInEditMode.bind(this);

    this._handleAddFieldButton = this._handleAddFieldButton.bind(this);
    this._renderNewCustomFields = this._renderNewCustomFields.bind(this);

    this._handleSyncSharedFields = this._handleSyncSharedFields.bind(this);
    this._handleEditSharedFields = this._handleEditSharedFields.bind(this);
    this._handleSecondaryConfigEdit = this._handleSecondaryConfigEdit.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedMsDynamics = localizedStrings.components.integrations.ms_dynamics;
  }

  prepareUserConfiguration(integration) {
    this.setState({
      id: integration && integration.id,
      email: integration && integration?.configuration?.email || '',
      instance: integration && integration?.configuration?.instance || '',
      syncReadAssetEvent: integration && integration?.configuration?.syncReadAssetEvent || false,
      syncReadConversationEvent: integration && integration?.configuration?.syncReadConversationEvent || false,
      syncReshareConversationEvent: integration && integration?.configuration?.syncReshareConversationEvent || false,
      syncLeadCreatedEvent: integration && integration?.configuration?.syncLeadCreatedEvent || false,
      syncEmailSentEvent: integration && integration?.configuration?.syncEmailSentEvent || false,
      syncDeals: integration && integration?.configuration?.syncDeals || false,
      syncAssetDownloadEvent: integration && integration?.configuration?.syncAssetDownloadEvent,
      errors: {}
    })
  }

  prepareAdminConfiguration(primaryIntegration) {
    this.setState({
      primaryId: primaryIntegration && primaryIntegration.id,
      primaryEmail: primaryIntegration && primaryIntegration.configuration.email || '',
      primaryInstance: primaryIntegration && primaryIntegration.configuration.instance || '',
      primarySyncReadAssetEvent: primaryIntegration && primaryIntegration.configuration.syncReadAssetEvent || false,
      primarySyncReadConversationEvent: primaryIntegration && primaryIntegration.configuration.syncReadConversationEvent || false,
      primarySyncReshareConversationEvent: primaryIntegration && primaryIntegration.configuration.syncReshareConversationEvent || false,
      primarySyncLeadCreatedEvent: primaryIntegration && primaryIntegration.configuration.syncLeadCreatedEvent || false,
      primarySyncDeals: primaryIntegration && primaryIntegration.configuration.syncDeals || false,
      primarySyncEmailSentEvent: primaryIntegration && primaryIntegration.configuration.syncEmailSentEvent || false,
      primaryCreatedBy: primaryIntegration && primaryIntegration.createdBy,
      primarySyncAssetDownloadEvent: primaryIntegration && primaryIntegration.configuration.syncAssetDownloadEvent
    })
  }

  componentDidMount() {
    const integration = _.get(this.props, 'integration');
    const primaryIntegration = _.get(integration, 'primaryIntegration');
    const integrationStateCode = _.get(integration, 'state.code');

    if (primaryIntegration) {
      const primaryIntegrationId = _.get(primaryIntegration, 'id');
      this.fetchCustomFields(primaryIntegrationId);
      this.prepareAdminConfiguration(primaryIntegration);
      this.setState({
        toggleCollapse: true
      })

      if (integrationStateCode === "ok") {
        this.prepareUserConfiguration(integration);
        this.setState({
          toggleCollapse: false
        })
      }
    } else if (integration) {
      const integrationId = _.get(integration, 'id');
      this.fetchCustomFields(integrationId);
      this.prepareAdminConfiguration(integration);
    }
  }

  fetchCustomFields(integrationId) {
    let filters = {
      types: []
    }
    this.props.fetchOpportunityFields(integrationId, filters);
    this.props.fetchCustomFields(integrationId);
  }

  componentWillReceiveProps(nextProps) {
     if (!isEqual(nextProps.integration, this.props.integration)) {
      if (nextProps.integration) {
        if (nextProps.integration.primaryIntegration) {
          this.prepareAdminConfiguration(nextProps.integration.primaryIntegration);
          this.fetchCustomFields(nextProps.integration.primaryIntegration.id);
          if (_.get(nextProps, "integration.state.code") === "ok") {
            this.setState({
              toggleCollapse: false
            })
            this.prepareUserConfiguration(nextProps.integration)
          }
        } else {
          this.setState({
            toggleCollapse: true
          })
          this.prepareAdminConfiguration(nextProps.integration);
          this.fetchCustomFields(nextProps.integration.id);
        }
      }
    }
    this.setState({
      customFields: nextProps.customFields,
      opportunityFields: nextProps.opportunityFields,
    });
  }

  _removeCustomField(field) {
    var removeCustomFields = this.state.removeCustomFields;
    removeCustomFields.push(field.id);

    this.setState({
      removeCustomFields: removeCustomFields,
    });
  }

  _handleAddFieldButton(item) {
    this.setState({
      ...this.state,
      showAddFieldButton: !this.state.showAddFieldButton,
    });
  }


  handleEditClick() {
    this.setState({
      editMode: true
    })
  }

  handleRemoveClick() {
    this.props.deactivateMsDynamicsIntegration("ms-dynamics_v2").then(() => {
      this.setState({
        id: null,
        toggleCollapse:true
      })
    })
  }

  _toggleSwitchChange(field) {
    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(type) {

    let request = {
      integrationId: type === 'primary' ? this.state.primaryId : this.state.id,
      syncReadAssetEvent: type === 'primary' ? this.state.primarySyncReadAssetEvent : this.state.syncReadAssetEvent,
      syncReadConversationEvent: type === 'primary' ? this.state.primarySyncReadConversationEvent : this.state.syncReadConversationEvent,
      syncReshareConversationEvent: type === 'primary' ? this.state.primarySyncReshareConversationEvent : this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: type === 'primary' ? this.state.primarySyncLeadCreatedEvent : this.state.syncLeadCreatedEvent,
      syncDeals: type === 'primary' ? this.state.primarySyncDeals : this.state.syncDeals,
      syncEmailSentEvent: type === 'primary' ? this.state.primarySyncEmailSentEvent : this.state.syncEmailSentEvent,
      syncAssetDownloadEvent: type === 'primary' ? this.state.primarySyncAssetDownloadEvent : this.state.syncAssetDownloadEvent,
    }

    this.props.updateConfiguration(request).then(() => {
      toast(
        <Toast.Sucess
          message={this.localizedIntegrations.toast.ms_dynamics}
        />, {
        autoClose: 3000,
      });
      this.setState({
        isSecondaryConfigEdit: false,
        editMode: false
      })
    });

    if (!_.isEmpty(this.state.newCustomFields)) {
      this.props.saveOpportunityFields(
        this.state.primaryId,
        this.state.newCustomFields
      )
        .then(() => {
          this.setState({
            newCustomFields: [],
            customFields: this.props.customFields,
          });
        });
    }

    if (!_.isEmpty(this.state.removeCustomFields)) {
      this.props.deleteCustomFields(
        this.state.primaryId,
        this.state.removeCustomFields
      )
        .then(() => {
          this.setState({ sharedFieldsEdit: false, removeCustomFields: [] });
        });
    }
  }

  _handlePrimaryResetClicked() {
    let integration = this.props.integration;
    if (this.props.integration.primaryIntegration) {
      integration = this.props.integration.primaryIntegration
    }

    this.setState({
      primarySyncReadAssetEvent: integration.configuration.syncReadAssetEvent,
      primarySyncReadConversationEvent: integration.configuration.syncReadConversationEvent,
      primarySyncReshareConversationEvent: integration.configuration.syncReshareConversationEvent,
      primarySyncLeadCreatedEvent: integration.configuration.syncLeadCreatedEvent,
      primarySyncDeals: integration.configuration.syncDeals,
      primarySyncEmailSentEvent: integration.configuration.syncEmailSentEvent,
      primarySyncAssetDownloadEvent: integration.configuration.syncAssetDownloadEvent,
      sharedFieldsEdit: false,
      showAddFieldButton: true,
      customFields: this.props.customFields,
      removeCustomFields: [],
      newCustomFields: [],
    });
  }

  _handleResetClicked() {
    this.setState({
      syncReadAssetEvent: this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent: this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent: this.props.integration.configuration.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.props.integration.configuration.syncLeadCreatedEvent,
      syncDeals: this.props.integration.configuration.syncDeals,
      syncAssetDownloadEvent: this.props.integration.configuration.syncAssetDownloadEvent,
      syncEmailSentEvent: this.props.integration.configuration.syncEmailSentEvent,
    });
  }


  showOverrideConfig() {
    if (!this.state.id && this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id !== this.props.user.id
    }
    return false;
  }

  userOverriding() {
    if (this.props.authenticating && this.state.primaryId) {
      return true;
    }
    return false;
  }

  _renderAddNewCustomFieldButton() {
    var opportunityFields = this.state.opportunityFields;

    if (this.state.newCustomFields) {
      var selectedFields = this.state.newCustomFields.map((item) => item.name);

      opportunityFields = [
        ...opportunityFields.filter(
          (item) => selectedFields.indexOf(item.name) === -1
        ),
      ];
    }

    if (this.state.customFields) {
      var selectedFields = this.state.customFields.map(
        (item) => item.integrationFieldId
      );

      opportunityFields = [
        ...opportunityFields.filter(
          (item) => selectedFields.indexOf(item.name) === -1
        ),
      ];
    }

    if (
      this.state.newCustomFields.length > 0 &&
      opportunityFields.length === 0
    ) {
      return <span></span>;
    }

    if (this.state.showAddFieldButton) {
      return (
        <div className={styles.addFields}>
          <div
            className={styles.button}
            onClick={() => {
              this._handleAddFieldButton()
              this.handleEditClick()
            }}
          >
            <i
              className={cx("paperflite-add", styles.add)}
              aria-hidden="true"
            />
            {this.localizedIntegrations.add_fields}
          </div>
        </div>
      );
    }

    return (
      <div className={styles.opportunityField}>
        <OpportunityFieldDropdown
          fields={[...opportunityFields]}
          addNewCustomField={(field)=> this._addNewCustomField(field)}
          onRemove={this._handleAddFieldButton}
        />
      </div>
    );
  }


  _removeNewCustomField(field) {
    var newCustomFields = [
      ...this.state.newCustomFields.filter((item) => item.name !== field.name),
    ];

    this.setState({
      newCustomFields: newCustomFields,
    });
  }

  _addNewCustomField(field) {
    if (!field) {
      return;
    }

    var newCustomFields = this.state.newCustomFields;
    newCustomFields.push(field);

    this.setState({
      ...this.state,
      showAddFieldButton: true,
      newCustomFields: newCustomFields,
    });
  }

  _renderNewCustomFields() { 
    var items = this.state.newCustomFields || [];

    var fields = items.map((field, index) => {
      return (
        <div className={styles.opportunityField} key={index}>
          <OpportunityFieldDropdown
            key={field.name}
            fields={[...this.state.opportunityFields]}
            selected={field}
            onRemove={this._removeNewCustomField}
            addNewCustomField={(field)=> this._addNewCustomField(field)}

          />
        </div>
      );
    });

    return fields;
  }

  _renderCustomFieldsInTags() {
    var items = this.state.customFields || [];

    return (
      <div className={styles.customFields}>
        {items.map((field, index) => {
          return (
            <div key={index} className={styles.text}>
              {field.name}
            </div>
          );
        })}
      </div>
    );
  }

  _renderCustomFieldsInEditMode() {
    var removeCustomFields = this.state.removeCustomFields;

    var fields = this.state.customFields
      .filter((field, index) => removeCustomFields.indexOf(field.id) === -1)
      .map((field, index) => {
        return (
          <div className={styles.opportunityField} key={index}>
            <CustomFieldDropdown
              key={field.name}
              selected={{ ...field }}
              removeCustomField={this._removeCustomField}
            />
          </div>
        );
      });

    return fields;
  }


  _handleEditSharedFields() {
    this.setState({ sharedFieldsEdit: true });
    this.handleEditClick()
  }

  _handleSyncSharedFields() {
    if (this.props.integration) {
      this.setState({
        sharedFieldsSync: true,
        showAddFieldButton: true,
        removeCustomFields: [],
        newCustomFields: [],
      });

      this.props.syncOpportunityFields(this.state.primaryId).then(() => {
        toast(
          <Toast.Sucess
            message={this.localizedMsDynamics.toast}
          />,
          {
            autoClose: 3000,
          }
        );

        this.setState({
          sharedFieldsSync: false,
          sharedFieldsEdit: false,
          removeCustomFields: [],
          newCustomFields: [],
          customFields: this.props.customFields,
        });
      });

      this.props.fetchOpportunityFields(this.state.primaryId).then(() => {
        this.setState({ opportunityFields: this.props.opportunityFields });
      });
    }
  }

  render() {
    return (
      <div className={styles.content}>
        {this.props.integration && _.get(this.props,"integration.state.code") === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {!this.props.loading && this.renderAdvancedSettings()}

        {(this.props.loading || this.userOverriding()) && this._renderLoading()}

        {(!this.props.authenticating && !this.props.loading && !this.state.id) && <div className={cx(styles.override)} onClick={() => {
         this.setState(()=>{
           return{
            toggleCollapse: false
           }
         }) 
        this.props.OverrideConfig()
        }}>{ this.localizedIntegrations.override_configuration }</div>}

        {this.state.id &&
          <Row className={cx(styles.overrideSettings, styles.row)}>
            <Col md={8} className={cx(styles.noPadding, styles.overrideHeaderRow)}>
                  <span className={styles.overrideHeader}>{ this.localizedIntegrations.override_configuration } </span>
              <span className={styles.remove} onClick={this.handleRemoveClick.bind(this)}>{ this.localizedCommons.actions.remove }</span>
            </Col>
            <Col md={12}>
              {!this.props.loading && this._renderUserConfiguration()}
            </Col>
          </Row>
        }

      </div>
    )
  }

  renderAdvancedSettings() {

    return (
      <>
        <Row className={cx(styles.settings, styles.row)} onClick={()=>{
          if(!this.state.id){
            return
          }
          this.setState({
            toggleCollapse: !this.state.toggleCollapse
          })
        }}>
        <Col md={8} className={cx(styles.noPadding,styles.headerRow)}>
              <i className={
                cx({
                  ['paperflite-plus'] : !this.state.toggleCollapse && this.state.id,
                  ['paperflite-minus'] : this.state.toggleCollapse && this.state.id,
                }
                )
              } aria-hidden="true"></i>
              <span className={styles.settingsHeader}>{ this.localizedIntegrations.primary_configuration }</span>
        </Col>
      </Row>
          <Collapse in = {this.state.toggleCollapse}>

            {!this.props.loading && this._renderAdminConfiguration()}
          </Collapse> 
      </>
    )
  }


  _renderAdminConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8} className={styles.settingsBody}>
          {!this.state.editMode && this.props.user.admin && (
            <span
              className={styles.edit}
              onClick={this.handleEditClick.bind(this)}
            >
              { this.localizedCommons.actions.edit }
            </span>
          )}
          <div className={styles.form}>
            <p className={styles.errorMessage}>
              {this.state.errors && this.state.errors.apikey}
            </p>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedIntegrations.instance_name }</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryInstance}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              { this.localizedMsDynamics.active }
            </Form.Text>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryEmail}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              { this.localizedMsDynamics.active_email }
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.sharedFields)}>
              <InputGroup>
                <InputGroup.Text className={styles.text}>
                  <h5> { this.localizedIntegrations.shared_fields } </h5>
                </InputGroup.Text>

                <ButtonGroup className={cx(styles.btnGroup, "pull-right")}>
                  {!_.isEmpty(this.props.customFields) && this.canEdit() && (
                    <>
                      {!this.state.sharedFieldsEdit && (
                        <Button
                          variant='tertiary'
                          text={this.localizedCommons.actions.edit}
                          className={styles.btn}
                          onClick={() => this._handleEditSharedFields()}
                        >
                        </Button>
                      )}
                      <Button
                        variant='tertiary'
                        text={this.state.sharedFieldsSync ? "SYNCING" : "SYNC"}
                        icon='fa-solid fa-refresh'
                        className={styles.btn}
                        onClick={() => this._handleSyncSharedFields()}
                      >
                  
                      </Button>
                      </>
   
                  )}
                </ButtonGroup>
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              { this.localizedMsDynamics.help_text }
            </Form.Text>

            {this.state.sharedFieldsEdit
              ? this._renderCustomFieldsInEditMode()
              : this._renderCustomFieldsInTags()}

            {this.props.loadingFields && _.isEmpty(this.props.opportunityFields) && (
              <div className={styles.loadingFields}>
                <span
                  className={cx("fa-solid fa-refresh", styles.loadingIcon)}
                />
                <span className={styles.loadingContent}>{ this.localizedCommons.loading.fields }...</span>
              </div>
            )}

            {this.canEdit() && (
              <div>
                {this._renderNewCustomFields()}

                {!_.isEmpty(this.props.opportunityFields) &&
                  this._renderAddNewCustomFieldButton()}
              </div>
            )}

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>
              { this.localizedMsDynamics.configuration }
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncLeadCreatedEvent"
                    checked={this.state.primarySyncLeadCreatedEvent}
                    handleCheck={() => this._toggleSwitchChange("primarySyncLeadCreatedEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncLeadCreatedEvent })}>{this.state.primarySyncLeadCreatedEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.sync_deals }</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncDeals"
                    checked={this.state.primarySyncDeals}
                    handleCheck={() => this._toggleSwitchChange("primarySyncDeals")}
                  />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncDeals })}>{this.state.primarySyncDeals ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>
                <div className={styles.event}>
                <label>Email sent</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncEmailSentEvent"
                    checked={this.state.primarySyncEmailSentEvent}
                    handleCheck={()=>this._toggleSwitchChange("primarySyncEmailSentEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncEmailSentEvent })}>{this.state.primarySyncEmailSentEvent ?this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncReadAssetEvent"
                    checked={this.state.primarySyncReadAssetEvent}
                    handleCheck={()=>this._toggleSwitchChange("primarySyncReadAssetEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncReadAssetEvent })}>{this.state.primarySyncReadAssetEvent ?this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncReadConversationEvent"
                    checked={this.state.primarySyncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("primarySyncReadConversationEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncReadConversationEvent })}>{this.state.primarySyncReadConversationEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncReshareConversationEvent"
                    checked={this.state.primarySyncReshareConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("primarySyncReshareConversationEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncReshareConversationEvent })}>{this.state.primarySyncReshareConversationEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>
                {this.state.editMode &&
                  <SwitchButton 
                    className={styles.switch}
                    id="primarySyncAssetDownloadEvent"
                    checked={this.state.primarySyncAssetDownloadEvent}
                    handleCheck={()=>this._toggleSwitchChange("primarySyncAssetDownloadEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.primarySyncAssetDownloadEvent })}>{this.state.primarySyncAssetDownloadEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off }</span>
                }
              </div>

            </FormGroup>

            {this.state.editMode &&
              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="paperflite-tick"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving}...` : this.localizedCommons.actions.save}
                  primary
                  disabled={this.props.updating}
                  onClick={() => this._handleSaveChangesClicked('primary')}
                >
                </SendButton>
                <SendButton
                  title={this.localizedCommons.actions.reset}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={this._handlePrimaryResetClicked}
                >
                </SendButton>
              </div>
            }
          </div>
        </Col>
      </Row>
    );
  }

  _handleSecondaryConfigEdit() {
    this.setState(prevState => ({
      editMode: true,
      isSecondaryConfigEdit: !prevState.isSecondaryConfigEdit
    }));
  }
  _renderUserConfiguration() {
    return (
      <Row className={styles.row}>
        <Col md={8}>
          <div className={styles.form}>
            <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedIntegrations.instance_name }</span>
                </InputGroup.Text>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.instance}
                  disabled />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>{ this.localizedMsDynamics.active }</Form.Text>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </InputGroup.Text>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.email}
                  disabled
                />
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>{ this.localizedMsDynamics.email }</Form.Text>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
                <div className={cx(styles.secondaryConfigEdit)} onClick={this._handleSecondaryConfigEdit.bind(this)}>
                  {!this.state.isSecondaryConfigEdit && <span> <i className="paperflite-edit" /> {this.localizedCommons.actions.edit} </span>}
                </div>
              </InputGroup>
            </FormGroup>
            <Form.Text className={styles.helpText}>Configuration for the events to publish to MsDynamics</Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>

                {
                  this.state.editMode &&    <SwitchButton 
                  id="syncLeadCreatedEvent"
                  className={styles.switch}
                  checked={this.state.syncLeadCreatedEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncLeadCreatedEvent")} />
                }
                {
                  !this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncLeadCreatedEvent })}>{this.state.syncLeadCreatedEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                
                }
             
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.sync_deals }</label>
                {
                  this.state.editMode && <SwitchButton 
                  id="syncDeals"
                  className={styles.switch}
                  checked={this.state.syncDeals}
                  handleCheck={()=>this._toggleSwitchChange("syncDeals")}
                />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncDeals })}>{this.state.syncDeals ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                }
                
              </div>
                 <div className={styles.event}>
                <label>Email sent</label>
                {
                  this.state.editMode && <SwitchButton 
                  id="syncEmailSentEvent"
                  className={styles.switch}
                  checked={this.state.syncEmailSentEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncEmailSentEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncEmailSentEvent })}>{this.state.syncEmailSentEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                {
                  this.state.editMode && <SwitchButton 
                  id="syncReadAssetEvent"
                  className={styles.switch}
                  checked={this.state.syncReadAssetEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReadAssetEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncReadAssetEvent })}>{this.state.syncReadAssetEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>
                {this.state.editMode &&
                  <SwitchButton name="syncReadConversationEvent"
                    className={styles.switch}
                    checked={this.state.syncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncReadConversationEvent })}>{this.state.syncReadConversationEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                {this.state.editMode &&
                  <SwitchButton name="syncReshareConversationEvent"
                    className={styles.switch}
                    checked={this.state.syncReshareConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncReshareConversationEvent })}>{this.state.syncReshareConversationEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                }
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>
                {this.state.editMode &&
                  <SwitchButton name="syncAssetDownloadEvent"
                    className={styles.switch}
                    checked={this.state.syncAssetDownloadEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncAssetDownloadEvent")} />
                }
                {!this.state.editMode &&
                  <span className={cx(styles.action, { [styles.on]: this.state.syncAssetDownloadEvent })}>{this.state.syncAssetDownloadEvent ? this.localizedIntegrations.actions.on : this.localizedIntegrations.actions.off}</span>
                }
              </div>
            </FormGroup>
            {this.state.isSecondaryConfigEdit &&
            <div className={styles.buttonTray}>
              <SendButton
                className={cx(styles.save)}
                icon="paperflite-tick"
                title={this.props.updating ? `${this.localizedCommons.actions.saving}...` : this.localizedCommons.actions.save}
                primary
                disabled={this.props.updating}
                onClick={() => this._handleSaveChangesClicked('user')}
              >
              </SendButton>
              <SendButton
                title={this.localizedCommons.actions.cancel}
                disabled={this.props.updating}
                className={cx(styles.cancel)}
                onClick={() => {
                    this._handleResetClicked();
                    this.setState({ isSecondaryConfigEdit: false })
                  }}
              >
              </SendButton>
            </div>
            }
          </div>
        </Col>
      </Row>
    );
  }


  _renderLoading() {
    return (
      <LoadingMessage
        className={cx(styles.loadingMessage, { [styles.userOverriding]: this.userOverriding() })}
        message={this.userOverriding() ? `${this.localizedMsDynamics.loading.override}...` : `${this.localizedMsDynamics.loading.config}...`}
        visible={true} />
    )
  }

  canEdit() {
    if (this.props.user.admin) {
      return true;
    } else if (this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id === this.props.user.id;
    }
    return false;
  }
}

export default MsDynamicsConfigurationView;